var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['disable-button-border-none trash-icon-wrap', _vm.classButtonWrap],attrs:{"disabled":_vm.statusEditable},on:{"click":function($event){return _vm.$emit('showConfirmModal')}}},[_c('span',{class:_vm.classSpan},[_c('i',{staticClass:"fas fa-trash-alt trash-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }